import axios from "axios"
import {API_BASE_URL} from "../../constants";

export class MemberScanServices{

    getMemberDetails(memberId){
        return axios.get(`${API_BASE_URL}/scp/api/users/member/${memberId}`)
        .then(res => res.data).catch(error => console.error(error));
    }
}